var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaxfreeMostPur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 179.953,
    height: 177.878,
    viewBox: "0 0 179.953 177.878",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.283,
    y1: 0.022,
    x2: 0.95,
    y2: 0.749,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f91818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ea52c6"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_94193",
    x: 2.056,
    y: 0,
    width: 177.897,
    height: 168.756,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.401,
    dy: 2.401,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.201,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_47735",
    "data-name": "Group 47735",
    transform: "translate(0 1.201)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94192",
    "data-name": "Path 94192",
    d: "M1300.429,416.558l3.789-20.421,82.968.239-27.276,20.689Z",
    transform: "translate(-1300.429 -396.137)",
    fill: "#760000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94191",
    "data-name": "Path 94191",
    d: "M1457.925,540.879l-.261-3.3.261-.363v-3.837l-.29-27.448,17.152,17.933.424,1.863Z",
    transform: "translate(-1301.279 -364.201)",
    fill: "#af007c"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, -1.2)",
    filter: "url(#Path_94193)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94193-2",
    "data-name": "Path 94193",
    d: "M1305.447,396.2l76.087,72.176,11.092,88.63L1221.932,395.452Z",
    transform: "translate(-1218.68 -394.25)",
    fill: "url(#linear-gradient)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxfreeMostPur);
export default __webpack_public_path__ + "static/media/taxfreeMostPur.a92560b038605cd391e4f183ac10a7e3.svg";
export { ForwardRef as ReactComponent };